// extracted by mini-css-extract-plugin
export default {"table":"Cart_table__ZS7G0","icons":"Cart_icons__oqJxX","summary":"Cart_summary__VR4tI","card":"Cart_card__ZZA2l","text":"Cart_text__CJRTl","count":"Cart_count__qv3kY"};